import * as bodyScrollLock from 'body-scroll-lock-upgrade';
// ShepherdJS requires you to use the scroll lock manually
// https://docs.shepherdjs.dev/recipes/cookbook/

export function disableBodyScroll(el) {
    bodyScrollLock.disableBodyScroll(el);
    console.log("debug", "disableBodyScroll", "body scroll disabled", { el });
}

export function enableBodyScroll() {
    bodyScrollLock.clearAllBodyScrollLocks();
    console.log("debug", "enableBodyScroll", "body scroll enabled");
}

export function startTour(tour) {
  tour.start();
  console.log('debug', 'tour', 'tour started', { tour });
}

export function cancelTour(tour) {
  tour.cancel();
  bodyScrollLock.clearAllBodyScrollLocks();
  console.log('debug', 'tour', 'tour cancelled', { tour });
}

export function completeTour(tour) {
  tour.complete();
  bodyScrollLock.clearAllBodyScrollLocks();
  console.log('debug', 'tour', 'tour completed', { tour });
}

export function buttons(tour) {
  return [
    {
      text: 'Next →',
      action: tour.next,
    },
    {
      text: 'Exit Tour',
      classes: 'cancel-btn-link-button',
      action: () => {
        // eslint-disable-next-line no-restricted-globals
        if (!confirm('Are you sure you want to exit the tour?')) {
          return;
        }
        cancelTour(tour);
        const url = new URL(window.location);
        const searchParams = new URLSearchParams(url.search);
        searchParams.delete('guided_tour_v2');
        searchParams.delete('step');
        url.search = `?${searchParams.toString()}`;
        window.location.assign(url.toString());
      },
    },
  ];
}

export function disableStepFocus(step) {
  step.on('show', () => {
    if (!step.el) return;
    step.el.originalFocus = step.el.focus;
    step.el.focus = () => {};
    console.log('debug', 'tour', `step ${step.id} focus disabled`, { step });
  });
  step.on('hide', () => {
    if (!step.el) return;
    step.el.focus = step.el.originalFocus;
    console.log('debug', 'tour', `step ${step.id} focus enabled`, { step });
  });
}
